function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ColorMap from "./ColorMap";
import isDefined from "../../Core/isDefined";
export default class ConstantColorMap extends ColorMap {
  constructor(options) {
    super();
    _defineProperty(this, "color", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "nullColor", void 0);
    this.color = options.color;
    this.title = options.title;
    this.nullColor = options.nullColor;
  }
  mapValueToColor(value) {
    if (this.nullColor && (value === null || !isDefined(value))) return this.nullColor;
    return this.color;
  }
}